import React from "react";
import Modal from "../../../../../../Components/Modal/Modal";
import NCZIEditContactPersonForm from "./NCZIEditContactPersonForm";
import {NCZIContactPerson} from "../../../../Interfaces/ncziPatientInformations";

interface Props {
    opened: boolean;
    onClose: (needReload: boolean) => void;
    patientIdentifier: string;
    contactPerson?: NCZIContactPerson
}

const NCZIEditContactPersonModal: React.FC<Props> = (props) => {
    const {
        opened,
        onClose,
        contactPerson,
        patientIdentifier
    } = props;

    return (
        <Modal opened={opened} onClose={() => onClose(false)} fullScreen={false}>
            <Modal.Header title={contactPerson ? 'base.shared.edit' : 'base.shared.add'} />
            <Modal.Content>
                <NCZIEditContactPersonForm onClose={onClose} contactPerson={contactPerson} patientIdentifier={patientIdentifier} />
            </Modal.Content>
        </Modal>
    );
}

export default NCZIEditContactPersonModal;